export default {
    change_timezone_title: "Cambiar la zona horaria",
    change_timezone_the_timezone_has_been_changed: "La zona horaria ha sido modificado",
    change_timezone_it_was_possible_to_change_the_timezone: "No es posible cambiar de zona horaria",
    change_timezone_device_name: "Nombre del dispositivo",
    change_timezone_timezone: "Zona horaria",
    change_timezone_warning_timezone: "Algunos de los dispositivos seleccionados ya tienen esta zona horaria",
    change_timezone_change: "Cambiar",
    change_timezpne_transaction_message: "La solicitud para cambiar la zona horaria ha sido enviada con éxito, por favor revise la lista de transacciones para ver el estado de la solicitud.",
};